module.exports = __webpack_public_path__ + "img/2m.b8958458.png";